'use client';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Users, MessageSquare, Rocket, ShieldCheck } from 'lucide-react';

const CONTACT_HREF = '/contact?subject=early-access';

export function EarlyAccessSection() {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[10%] right-[5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[10%] left-[5%] w-72 h-72 bg-blue-500/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <Badge
            variant="secondary"
            className="mb-6 px-4 py-1.5 text-sm bg-primary/10 text-primary border-primary/20"
          >
            Founding Partner Program
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground">
            Join our founding partner teams
          </h2>
          <p className="text-xl text-muted-foreground mb-4 max-w-2xl mx-auto">
            Currently onboarding 5 founding partner teams with priority setup and direct access to the product team.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
          <div className="text-center p-6 rounded-2xl border border-border bg-background hover:border-primary/20 transition-colors">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <MessageSquare className="w-6 h-6 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Shape the roadmap</h3>
            <p className="text-sm text-muted-foreground">
              Direct input on features and priorities. Your workflow needs drive what we build next.
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl border border-border bg-background hover:border-primary/20 transition-colors">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Priority onboarding</h3>
            <p className="text-sm text-muted-foreground">
              White-glove setup, data import assistance, and dedicated support throughout your pilot.
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl border border-border bg-background hover:border-primary/20 transition-colors">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <Rocket className="w-6 h-6 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Founding partner pricing</h3>
            <p className="text-sm text-muted-foreground">
              Lock in preferential terms before public launch. Your early commitment is rewarded.
            </p>
          </div>
        </div>

        <div className="text-center">
          <Button
            size="lg"
            className="h-12 px-8 text-base font-bold shadow-lg shadow-primary/20"
            onClick={() => {
              window.location.assign(CONTACT_HREF);
            }}
          >
            Request Access
          </Button>
          <div className="mt-6 flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-muted-foreground">
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-green-500" />
              European data residency
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-green-500" />
              Go live in 48 hours
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-green-500" />
              No commitment required
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
